
export default function Title({ title }) {
    return (
        <div className="text-gray-900 text-center md:my-20 my-10 text-4xl md:text-5xl font-bold">
            {title}
        </div>
    );
}
